<div class="grid-container padding-y-4">
  <div class="grid-row">
    @if (registrationType === 'Reporting Official') {
      <legend class="usa-legend usa-legend--large">Authorized Official
        Approval
      </legend>
    }
    @if (registrationType === 'User') {
      <legend class="usa-legend usa-legend--large">User Approval</legend>
    }
  </div>
  @if (registrationSuccessful) {
    <div class="grid-row">
      <div class="usa-alert usa-alert--success">
        <div class="usa-alert__body">
          <p class="usa-alert__text">
            {{this.message}}
            @if (this.customerApprovalForm.get('registrationStatus').value==='Accept') {
              <span>Please navigate to User Profile page and click on User List to update user's permissions.</span>
            }
          </p>
        </div>
      </div>
    </div>
  }
  @if (registrationFailure) {
    <div class="grid-row">
      <div class="usa-alert usa-alert--error" role="alert">
        <div class="usa-alert__body">
          <p class="usa-alert__text">
            {{this.message}}
          </p>
        </div>
      </div>
    </div>
  }
  <form [formGroup]="customerApprovalForm">
    <fieldset class="usa-fieldset">
      @if (!registrationSuccessful) {
        <div>
          <div class="form-row" >
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="customer_name" class="usa-label">Agency Name</label>
              <input type="text" id="customer_name" class="usa-input" readonly formControlName="agencyName">
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="bureau_name" class="usa-label">Bureau Name</label>
              <input type="text" id="bureau_name" class="usa-input" readonly formControlName="bureauName">
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="permissions" class="usa-label">Permissions</label>
              <input type="text" id="permissions" class="usa-input" readonly formControlName="permissionReadOnly">
            </div>
          </div>
          <hr>
            <!-- Hide this block if reporting official -->
            @if (isRegistrationTypeUser) {
              <legend class="usa-legend usa-legend--medium">Agency User Information</legend>
            }
            @if (!isRegistrationTypeUser) {
              <legend class="usa-legend usa-legend--medium">Authorized Official Information</legend>
            }
            @if (isRegistrationTypeUser) {
              <div class="grid-row grid-gap-0">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                  <label for="user_first_name" class="usa-label">First Name</label>
                  <input type="text" required class="usa-input" formControlName="firstName" id="user_first_name"
                    [maxlength]="35"
                   [ngClass]="{
                      'border-success': this.customerApprovalForm.get('firstName').valid && this.customerApprovalForm.get('firstName').touched,
                      'border-danger': this.customerApprovalForm.get('firstName').invalid && this.customerApprovalForm.get('firstName').touched
                      }"
                    >
                  @if (this.customerApprovalForm.get('firstName').invalid && (this.customerApprovalForm.get('firstName').touched
                    || this.customerApprovalForm.get('firstName').dirty)) {
                    <div>
                      <small class="text-danger">
                        <span class="fa fa-warning"></span> First Name is required
                      </small>
                    </div>
                  }
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                  <label for="user_middle_name" class="usa-label">Middle Initial</label>
                  <input type="text" id="user_middle_name" class="usa-input" formControlName="middleInitial" [maxlength]="1">
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                  <label for="user_last_name" class="usa-label">Last Name</label>
                  <input type="text" id="user_last_name" class="usa-input" formControlName="lastName" [maxlength]="35"
                   [ngClass]="{
                      'border-success': this.customerApprovalForm.get('lastName').valid && this.customerApprovalForm.get('lastName').touched,
                      'border-danger': this.customerApprovalForm.get('lastName').invalid && this.customerApprovalForm.get('lastName').touched
                    }"
                    >
                  @if (this.customerApprovalForm.get('lastName').invalid && (this.customerApprovalForm.get('lastName').touched
                    || this.customerApprovalForm.get('lastName').dirty)) {
                    <div>
                      <small class="text-danger">
                        <span class="fa fa-warning"></span> Last Name is required
                      </small>
                    </div>
                  }
                </div>
              </div>
            }
            @if (isRegistrationTypeUser) {
              <div class="form-row">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                  <label for="user_email" class="usa-label">Email</label>
                  <input type="text" id="user_email" class="usa-input" formControlName="email" readonly [maxlength]="254"
                   [ngClass]="{
                      'border-success': this.customerApprovalForm.get('email').valid && this.customerApprovalForm.get('email').touched,
                      'border-danger': this.customerApprovalForm.get('email').invalid && this.customerApprovalForm.get('email').touched
                    }"
                    >
                  @if (this.customerApprovalForm.get('email').invalid && (this.customerApprovalForm.get('email').touched
                    || this.customerApprovalForm.get('email').dirty)) {
                    <div>
                      <small class="text-danger">
                        <span class="fa fa-warning"></span> Email is required
                      </small>
                    </div>
                  }
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                  <label for="user_phone" class="usa-label">Phone</label>
                  <input type="text" id="user_phone" class="usa-input" formControlName="phone" [maxlength]="20"
                   [ngClass]="{
                      'border-success': this.customerApprovalForm.get('phone').valid && this.customerApprovalForm.get('phone').touched,
                      'border-danger': this.customerApprovalForm.get('phone').invalid && this.customerApprovalForm.get('phone').touched
                    }"
                    >
                  <span class="help-text text-muted">Do not include spaces or dashes.</span>
                  @if (this.customerApprovalForm.get('phone').invalid && (this.customerApprovalForm.get('phone').touched
                    || this.customerApprovalForm.get('phone').dirty)) {
                    <div>
                      <small class="text-danger">
                        <span class="fa fa-warning"></span> Phone is required
                      </small>
                    </div>
                  }
                  @if (this.customerApprovalForm.get('phone').invalid && (this.customerApprovalForm.get('phone').touched
                    || this.customerApprovalForm.get('phone').dirty)) {
                    <div>
                      <small class="text-danger">
                        <span class="fa fa-warning"></span> Invalid phone number
                      </small>
                    </div>
                  }
                  @if (this.customerApprovalForm.get('phone').invalid && (this.customerApprovalForm.get('phone').touched
                    || this.customerApprovalForm.get('phone').dirty)) {
                    <div>
                      <small class="text-danger">
                        <span class="fa fa-warning"></span> Phone number must be at least 10 digits
                      </small>
                    </div>
                  }
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                  <label for="user_phone_ext" class="usa-label">Ext</label>
                  <input type="text" id="user_phone_ext" class="usa-input" formControlName="phoneExtension" appNumbersOnly
                    [maxlength]="10">
                </div>
              </div>
            }
            <hr>
              @if (isRegistrationTypeUser) {
                <legend class="usa-legend usa-legend--medium">Authorized Official Information</legend>
              }
              <div class="form-row">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                  <label for="reporting_first_name" class="usa-label">First Name</label>
                  <input type="text" id="reporting_first_name" class="usa-input" formControlName="reportingOfficialFirstName"
                    [maxlength]="35"
                   [ngClass]="{
                      'border-success': this.customerApprovalForm.get('reportingOfficialFirstName').valid && this.customerApprovalForm.get('reportingOfficialFirstName').touched,
                      'border-danger': this.customerApprovalForm.get('reportingOfficialFirstName').invalid && this.customerApprovalForm.get('reportingOfficialFirstName').touched
                    }"
                    >
                  @if (this.customerApprovalForm.get('reportingOfficialFirstName').invalid && (this.customerApprovalForm.get('reportingOfficialFirstName').touched
                    || this.customerApprovalForm.get('reportingOfficialFirstName').dirty)) {
                    <div>
                      <small class="text-danger">
                        <span class="fa fa-warning"></span> First Name is required
                      </small>
                    </div>
                  }
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                  <label for="reporting_middle_name" class="usa-label">Middle Initial</label>
                  <input type="text" id="reporting_middle_name" class="usa-input"
                    formControlName="reportingOfficialMiddleInitial"
                    [maxlength]="1">
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                  <label for="reporting_last_name" class="usa-label">Last Name</label>
                  <input type="text" id="reporting_last_name" class="usa-input" formControlName="reportingOfficialLastName"
                    [maxlength]="35"
                   [ngClass]="{
                      'border-success': this.customerApprovalForm.get('reportingOfficialLastName').valid && this.customerApprovalForm.get('reportingOfficialLastName').touched,
                      'border-danger': this.customerApprovalForm.get('reportingOfficialLastName').invalid && this.customerApprovalForm.get('reportingOfficialLastName').touched
                    }"
                    >
                  @if (this.customerApprovalForm.get('reportingOfficialLastName').invalid && (this.customerApprovalForm.get('reportingOfficialLastName').touched
                    || this.customerApprovalForm.get('reportingOfficialLastName').dirty)) {
                    <div>
                      <small class="text-danger">
                        <span class="fa fa-warning"></span> Last Name is required
                      </small>
                    </div>
                  }
                </div>
              </div>
              <div class="form-row">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                  <label for="reporting_title" class="usa-label">Title</label>
                  <input type="text" id="reporting_title" class="usa-input" formControlName="reportingOfficialTitle"
                    [maxlength]="45"
                   [ngClass]="{
                      'border-success': this.customerApprovalForm.get('reportingOfficialTitle').valid && this.customerApprovalForm.get('reportingOfficialTitle').touched,
                      'border-danger': this.customerApprovalForm.get('reportingOfficialTitle').invalid && this.customerApprovalForm.get('reportingOfficialTitle').touched
                    }"
                    >
                  @if (this.customerApprovalForm.get('reportingOfficialTitle').invalid && (this.customerApprovalForm.get('reportingOfficialTitle').touched
                    || this.customerApprovalForm.get('reportingOfficialTitle').dirty)) {
                    <div>
                      <small class="text-danger">
                        <span class="fa fa-warning"></span> Title is required
                      </small>
                    </div>
                  }
                </div>
              </div>
              <div class="form-row">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                  <label for="reporting_address" class="usa-label">Address1</label>
                  <input type="text" id="reporting_address" class="usa-input" formControlName="reportingOfficialAddressLine1"
                    [maxlength]="345"
                   [ngClass]="{
                      'border-success': this.customerApprovalForm.get('reportingOfficialAddressLine1').valid && this.customerApprovalForm.get('reportingOfficialAddressLine1').touched,
                      'border-danger': this.customerApprovalForm.get('reportingOfficialAddressLine1').invalid && this.customerApprovalForm.get('reportingOfficialAddressLine1').touched
                    }"
                    >
                  @if (this.customerApprovalForm.get('reportingOfficialAddressLine1').invalid && (this.customerApprovalForm.get('reportingOfficialAddressLine1').touched
                    || this.customerApprovalForm.get('reportingOfficialAddressLine1').dirty)) {
                    <div>
                      <small class="text-danger">
                        <span class="fa fa-warning"></span> Address is required
                      </small>
                    </div>
                  }
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                  <label for="reporting_address_2" class="usa-label">Address 2</label>
                  <input type="text" id="reporting_address_2" class="usa-input"
                    formControlName="reportingOfficialAddressLine2"
                    [maxlength]="45">
                </div>
              </div>
              <div class="form-row">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                  <label for="reporting_city" class="usa-label">City</label>
                  <input type="text" id="reporting_city" class="usa-input" formControlName="reportingOfficialCity"
                    [maxlength]="45"
                   [ngClass]="{
                      'border-success': this.customerApprovalForm.get('reportingOfficialCity').valid && this.customerApprovalForm.get('reportingOfficialCity').touched,
                      'border-danger': this.customerApprovalForm.get('reportingOfficialCity').invalid && this.customerApprovalForm.get('reportingOfficialCity').touched
                    }"
                    >
                  @if (this.customerApprovalForm.get('reportingOfficialCity').invalid && (this.customerApprovalForm.get('reportingOfficialCity').touched
                    || this.customerApprovalForm.get('reportingOfficialCity').dirty)) {
                    <div>
                      <small class="text-danger">
                        <span class="fa fa-warning"></span> City is required
                      </small>
                    </div>
                  }
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                  <label for="reporting_state" class="usa-label">State</label>
                  <select id="reporting_state" class="usa-input" formControlName="reportingOfficialState"
                    title="reporting_state"
                    name="reportingOfficialState">
                    <option [value]='null' selected disabled>Choose...</option>
                    @for (s of stateList; track s) {
                      <option [value]="s.stateCountryCode">{{s.stateCountryName}}</option>
                    }
                  </select>
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                  <label for="reporting_zip" class="usa-label">Zip Code</label>
                  <input type="text" id="reporting_zip" class="usa-input" formControlName="reportingOfficialZip"
                    [maxlength]="5"
                   [ngClass]="{
                      'border-success': this.customerApprovalForm.get('reportingOfficialZip').valid && this.customerApprovalForm.get('reportingOfficialZip').touched,
                      'border-danger': this.customerApprovalForm.get('reportingOfficialZip').invalid && this.customerApprovalForm.get('reportingOfficialZip').touched
                    }"
                    >
                  @if (this.customerApprovalForm.get('reportingOfficialZip').invalid && (this.customerApprovalForm.get('reportingOfficialZip').touched
                    || this.customerApprovalForm.get('reportingOfficialZip').dirty)) {
                    <div>
                      <small class="text-danger">
                        <span class="fa fa-warning"></span> Zip Code is required
                      </small>
                    </div>
                  }
                </div>
              </div>
              <div class="form-row">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                  <label for="reporting_country" class="usa-label">Country</label>
                  <select id="reporting_country" class="usa-input" title="reporting_country" name="country"
                    formControlName="reportingOfficialCountry">
                    <option [value]='null' selected disabled>Choose...</option>
                    @for (c of countryList; track c) {
                      <option [value]="c.stateCountryName">{{c.stateCountryName}}</option>
                    }
                  </select>
                </div>
              </div>
              <div class="form-row">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                  <label for="reporting_phone" class="usa-label">Phone</label>
                  <input type="text" id="reporting_phone" class="usa-input" formControlName="reportingOfficialPhone"
                    [maxlength]="20"
                   [ngClass]="{
                      'border-success': this.customerApprovalForm.get('reportingOfficialPhone').valid && this.customerApprovalForm.get('reportingOfficialPhone').touched,
                      'border-danger': this.customerApprovalForm.get('reportingOfficialPhone').invalid && this.customerApprovalForm.get('reportingOfficialPhone').touched
                    }"
                    >
                  <span class="help-text text-muted">Do not include spaces or dashes.</span>
                  @if (this.customerApprovalForm.get('reportingOfficialPhone').invalid && (this.customerApprovalForm.get('reportingOfficialPhone').touched
                    || this.customerApprovalForm.get('reportingOfficialPhone').dirty)) {
                    <div>
                      <small class="text-danger">
                        <span class="fa fa-warning"></span> Phone is required
                      </small>
                    </div>
                  }
                  @if (this.customerApprovalForm.get('reportingOfficialPhone').invalid && (this.customerApprovalForm.get('reportingOfficialPhone').touched
                    || this.customerApprovalForm.get('reportingOfficialPhone').dirty)) {
                    <div>
                      <small class="text-danger">
                        <span class="fa fa-warning"></span> Invalid phone number
                      </small>
                    </div>
                  }
                  @if (this.customerApprovalForm.get('reportingOfficialPhone').invalid && (this.customerApprovalForm.get('reportingOfficialPhone').touched
                    || this.customerApprovalForm.get('reportingOfficialPhone').dirty)) {
                    <div>
                      <small class="text-danger">
                        <span class="fa fa-warning"></span> Phone number must be at least 10 digits
                      </small>
                    </div>
                  }
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                  <label for="reporting_phone_ext" class="usa-label">Ext</label>
                  <input type="text" id="reporting_phone_ext" class="usa-input"
                    formControlName="reportingOfficialPhoneExtension"
                    appNumbersOnly [maxlength]="10">
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                  <label for="reporting_email" class="usa-label">Email</label>
                  <input type="text" id="reporting_email" class="usa-input" formControlName="reportingOfficialEmail" readonly
                    [maxlength]="254"
                   [ngClass]="{
                      'border-success': this.customerApprovalForm.get('reportingOfficialEmail').valid && this.customerApprovalForm.get('reportingOfficialEmail').touched,
                      'border-danger': this.customerApprovalForm.get('reportingOfficialEmail').invalid && this.customerApprovalForm.get('reportingOfficialEmail').touched
                    }"
                    >
                  @if (this.customerApprovalForm.get('reportingOfficialEmail').invalid && (this.customerApprovalForm.get('reportingOfficialEmail').touched
                    || this.customerApprovalForm.get('reportingOfficialEmail').dirty)) {
                    <div>
                      <small class="text-danger">
                        <span class="fa fa-warning"></span> Email is required
                      </small>
                    </div>
                  }
                </div>
              </div>
              <hr>
                <legend class="usa-legend usa-legend--medium">Approval</legend>
                <div class="form-row">
                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    <label for="status" class="usa-label">Status<abbr title="required"
                    class="usa-hint usa-hint--required">*</abbr></label>
                    <select id="status" class="usa-select" formControlName="registrationStatus" title="registration_Status"
                      name="registrationStatus">
                      <option [value]='null' selected disabled>Choose...</option>
                      @for (s of statusTypes; track s) {
                        <option [value]="s">{{s}}</option>
                      }
                    </select>
                  </div>
                </div>
                @if (this.customerApprovalForm.get('registrationStatus').value==='Reject') {
                  <div class="grid-row">
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                      <label for="comments" class="usa-label">Reason<small class="required">*</small></label>
                      <textarea required class="usa-textarea maxw-full" formControlName="rejectReason" id="comments"></textarea>
                    </div>
                  </div>
                }
              </div>
            }
            <div class="margin-top-2">
              @if (!registrationSuccessful) {
                <button type="button" class="usa-button"
                  [disabled]="customerApprovalForm.invalid || this.checkSelectControlsSelected() || (this.isRegistrationRejected && this.registrationStatus === 'Accept')"
                  (click)='updateCustomer(this.customerApprovalForm.value)'>Submit
                </button>
              }
              <button type="button" class="usa-button usa-button usa-button--unstyled" (click)='callCustomerApprovalList()'>Back To
                Customer Approval
              </button>
            </div>
          </fieldset>
        </form>
      </div>


      <!--<div class="row">
      <div class="col-md-12">
        <div class="card shadow-sm">
          <div class="card-body p-5">
            <h3 class="p-0 mb-4" *ngIf="registrationType === 'Reporting Official'">Reporting Official Approval</h3>
            <h3 class="p-0 mb-4" *ngIf="registrationType === 'User'">User Approval</h3>
            <form [formGroup]="customerApprovalForm">
              <div *ngIf="registrationSuccessful" class="alert alert-success">
                {{this.message}}
                <p *ngIf="this.customerApprovalForm.get('registrationStatus').value==='Accept'">Please navigate to User Profile page and click on User List to update user's permissions.</p>
              </div>
              <div *ngIf="registrationFailure" class="alert alert-danger">
                {{this.message}}
              </div>
              <div *ngIf="!registrationSuccessful">
                <div class="form-row">
                  <div class="form-group col-md-5">
                    <label for="customer_name">Agency Name</label>
                    <input type="text" id="customer_name" class="w-100" readonly formControlName="agencyName">
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-5">
                    <label for="bureau_name">Bureau Name</label>
                    <input type="text" id="bureau_name" class="w-100" readonly formControlName="bureauName">
                  </div>
                </div>
                <div class="form-row d-block">
                  <h6 class="px-3 pt-3">Permissions</h6>
                  <div class="form-group pl-2">
                    <div class="form-check form-check-inline">
                      <input id="permissions_frt" formControlName="frtAccess" type="checkbox">
                      <label class="form-check-label" for="permissions_frt">Freight</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input id="permissions_hhg" formControlName="hhgAccess" type="checkbox">
                      <label class="form-check-label" for="permissions_hhg">Household Goods</label>
                    </div>
                  </div>
                  <small id="fnHelp" class="d-block pl-3 text-danger" *ngIf="permissionsSelected()">
                    <span class="fa fa-warning"></span> Check at least one permission type
                  </small>
                </div>

                &lt;!&ndash; Hide this block if reporting official &ndash;&gt;
                <h5 *ngIf="isRegistrationTypeUser">Information</h5>
                <h5 *ngIf="!isRegistrationTypeUser">Reporting Official</h5>
                <div class="form-row" *ngIf="isRegistrationTypeUser">
                  <div class="form-group col-md-5">
                    <label for="user_first_name">First Name</label>
                    <input type="text" required class="w-100" formControlName="firstName" id="user_first_name" [maxlength]="35"
                        [ngClass]="{
                    'border-success': this.customerApprovalForm.get('firstName').valid && this.customerApprovalForm.get('firstName').touched,
                    'border-danger': this.customerApprovalForm.get('firstName').invalid && this.customerApprovalForm.get('firstName').touched
                    }"
                      >
                  <div *ngIf="this.customerApprovalForm.get('firstName').invalid && (this.customerApprovalForm.get('firstName').touched
                  || this.customerApprovalForm.get('firstName').dirty)">
                      <small class="text-danger">
                        <span class="fa fa-warning"></span> First Name is required
                      </small>
                    </div>
                  </div>
                  <div class="form-group col-md-2">
                    <label for="user_middle_name">Middle Initial</label>
                    <input type="text" id="user_middle_name"  class="w-100" formControlName="middleInitial" [maxlength]="1">
                  </div>
                  <div class="form-group col-md-5">
                    <label for="user_last_name">Last Name</label>
                    <input type="text" id="user_last_name" class="w-100" formControlName="lastName" [maxlength]="35"
                        [ngClass]="{
                    'border-success': this.customerApprovalForm.get('lastName').valid && this.customerApprovalForm.get('lastName').touched,
                    'border-danger': this.customerApprovalForm.get('lastName').invalid && this.customerApprovalForm.get('lastName').touched
                  }"
                      >
                  <div *ngIf="this.customerApprovalForm.get('lastName').invalid && (this.customerApprovalForm.get('lastName').touched
                || this.customerApprovalForm.get('lastName').dirty)">
                      <small class="text-danger">
                        <span class="fa fa-warning"></span> Last Name is required
                      </small>
                    </div>
                  </div>
                </div>
                <div class="form-row" *ngIf="isRegistrationTypeUser">
                  <div class="form-group col-md-5">
                    <label for="user_email">Email</label>
                    <input type="text" id="user_email" class="w-100" formControlName="email" readonly [maxlength]="254"
                        [ngClass]="{
                    'border-success': this.customerApprovalForm.get('email').valid && this.customerApprovalForm.get('email').touched,
                    'border-danger': this.customerApprovalForm.get('email').invalid && this.customerApprovalForm.get('email').touched
                  }"
                      >
                  <div *ngIf="this.customerApprovalForm.get('email').invalid && (this.customerApprovalForm.get('email').touched
                || this.customerApprovalForm.get('email').dirty)">
                      <small class="text-danger">
                        <span class="fa fa-warning"></span> Email is required
                      </small>
                    </div>
                  </div>
                </div>
                <div class="form-row" *ngIf="isRegistrationTypeUser">
                  <div class="form-group col-md-5">
                    <label for="user_phone">Phone</label>
                    <input type="text" id="user_phone" class="w-100" formControlName="phone" [maxlength]="20"
                        [ngClass]="{
                    'border-success': this.customerApprovalForm.get('phone').valid && this.customerApprovalForm.get('phone').touched,
                    'border-danger': this.customerApprovalForm.get('phone').invalid && this.customerApprovalForm.get('phone').touched
                  }"
                      >
                    <span class="help-text text-muted">Do not include spaces or dashes.</span>
                  <div *ngIf="this.customerApprovalForm.get('phone').invalid && (this.customerApprovalForm.get('phone').touched
                  || this.customerApprovalForm.get('phone').dirty)">
                      <small class="text-danger">
                        <span class="fa fa-warning"></span> Phone is required
                      </small>
                    </div>
                  <div *ngIf="this.customerApprovalForm.get('phone').invalid && (this.customerApprovalForm.get('phone').touched
                  || this.customerApprovalForm.get('phone').dirty)">
                      <small class="text-danger">
                        <span class="fa fa-warning"></span> Invalid phone number
                      </small>
                    </div>
                  <div *ngIf="this.customerApprovalForm.get('phone').invalid && (this.customerApprovalForm.get('phone').touched
                  || this.customerApprovalForm.get('phone').dirty)">
                      <small class="text-danger">
                        <span class="fa fa-warning"></span> Phone number must be at least 10 digits
                      </small>
                    </div>
                  </div>
                  <div class="form-group col-md-2">
                    <label for="user_phone_ext">Ext</label>
                    <input type="text" id="user_phone_ext" class="w-100" formControlName="phoneExtension" appNumbersOnly [maxlength]="14">
                  </div>
                </div>

                <h5 *ngIf="isRegistrationTypeUser">Reporting Information</h5>
                <div class="form-row">
                  <div class="form-group col-md-5">
                    <label for="reporting_first_name">First Name</label>
                    <input type="text" id="reporting_first_name" class="w-100" formControlName="reportingOfficialFirstName" [maxlength]="35"
                        [ngClass]="{
                    'border-success': this.customerApprovalForm.get('reportingOfficialFirstName').valid && this.customerApprovalForm.get('reportingOfficialFirstName').touched,
                    'border-danger': this.customerApprovalForm.get('reportingOfficialFirstName').invalid && this.customerApprovalForm.get('reportingOfficialFirstName').touched
                  }"
                      >
                  <div *ngIf="this.customerApprovalForm.get('reportingOfficialFirstName').invalid && (this.customerApprovalForm.get('reportingOfficialFirstName').touched
                || this.customerApprovalForm.get('reportingOfficialFirstName').dirty)">
                      <small class="text-danger">
                        <span class="fa fa-warning"></span> First Name is required
                      </small>
                    </div>
                  </div>
                  <div class="form-group col-md-2">
                    <label for="reporting_middle_name">Middle Initial</label>
                    <input type="text" id="reporting_middle_name" class="w-100" formControlName="reportingOfficialMiddleInitial" [maxlength]="1">
                  </div>
                  <div class="form-group col-md-5">
                    <label for="reporting_last_name">Last Name</label>
                    <input type="text" id="reporting_last_name" class="w-100" formControlName="reportingOfficialLastName" [maxlength]="35"
                        [ngClass]="{
                    'border-success': this.customerApprovalForm.get('reportingOfficialLastName').valid && this.customerApprovalForm.get('reportingOfficialLastName').touched,
                    'border-danger': this.customerApprovalForm.get('reportingOfficialLastName').invalid && this.customerApprovalForm.get('reportingOfficialLastName').touched
                  }"
                      >
                  <div *ngIf="this.customerApprovalForm.get('reportingOfficialLastName').invalid && (this.customerApprovalForm.get('reportingOfficialLastName').touched
                || this.customerApprovalForm.get('reportingOfficialLastName').dirty)">
                      <small class="text-danger">
                        <span class="fa fa-warning"></span> Last Name is required
                      </small>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-5">
                    <label for="reporting_title">Title</label>
                    <input type="text" id="reporting_title" class="w-100" formControlName="reportingOfficialTitle" [maxlength]="45"
                        [ngClass]="{
                    'border-success': this.customerApprovalForm.get('reportingOfficialTitle').valid && this.customerApprovalForm.get('reportingOfficialTitle').touched,
                    'border-danger': this.customerApprovalForm.get('reportingOfficialTitle').invalid && this.customerApprovalForm.get('reportingOfficialTitle').touched
                  }"
                      >
                  <div *ngIf="this.customerApprovalForm.get('reportingOfficialTitle').invalid && (this.customerApprovalForm.get('reportingOfficialTitle').touched
                || this.customerApprovalForm.get('reportingOfficialTitle').dirty)">
                      <small class="text-danger">
                        <span class="fa fa-warning"></span> Title is required
                      </small>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-5">
                    <label for="reporting_address">Address1</label>
                    <input type="text" id="reporting_address" class="w-100" formControlName="reportingOfficialAddressLine1" [maxlength]="345"
                        [ngClass]="{
                    'border-success': this.customerApprovalForm.get('reportingOfficialAddressLine1').valid && this.customerApprovalForm.get('reportingOfficialAddressLine1').touched,
                    'border-danger': this.customerApprovalForm.get('reportingOfficialAddressLine1').invalid && this.customerApprovalForm.get('reportingOfficialAddressLine1').touched
                  }"
                      >
                  <div *ngIf="this.customerApprovalForm.get('reportingOfficialAddressLine1').invalid && (this.customerApprovalForm.get('reportingOfficialAddressLine1').touched
                || this.customerApprovalForm.get('reportingOfficialAddressLine1').dirty)">
                      <small class="text-danger">
                        <span class="fa fa-warning"></span> Address is required
                      </small>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-5">
                    <label for="reporting_address_2">Address 2</label>
                    <input type="text" id="reporting_address_2" class="w-100" formControlName="reportingOfficialAddressLine2" [maxlength]="45">
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-5">
                    <label for="reporting_city">City</label>
                    <input type="text" id="reporting_city" class="w-100" formControlName="reportingOfficialCity" [maxlength]="45"
                        [ngClass]="{
                    'border-success': this.customerApprovalForm.get('reportingOfficialCity').valid && this.customerApprovalForm.get('reportingOfficialCity').touched,
                    'border-danger': this.customerApprovalForm.get('reportingOfficialCity').invalid && this.customerApprovalForm.get('reportingOfficialCity').touched
                  }"
                      >
                  <div *ngIf="this.customerApprovalForm.get('reportingOfficialCity').invalid && (this.customerApprovalForm.get('reportingOfficialCity').touched
                || this.customerApprovalForm.get('reportingOfficialCity').dirty)">
                      <small class="text-danger">
                        <span class="fa fa-warning"></span> City is required
                      </small>
                    </div>
                  </div>
                  <div class="form-group col-md-5">
                    <label for="reporting_state">State</label>
                    <select id="reporting_state" class="w-100" formControlName="reportingOfficialState" title="reporting_state"  name="reportingOfficialState">
                      <option [value]='null' selected disabled>Choose...</option>
                      <option *ngFor='let s of stateList' [value]="s.stateCountryCode">{{s.stateCountryName}}</option>
                    </select>
                  </div>
                  <div class="form-group col-md-2">
                    <label for="reporting_zip">Zip Code</label>
                    <input type="text" id="reporting_zip" class="w-100" formControlName="reportingOfficialZip" [maxlength]="5"
                        [ngClass]="{
                    'border-success': this.customerApprovalForm.get('reportingOfficialZip').valid && this.customerApprovalForm.get('reportingOfficialZip').touched,
                    'border-danger': this.customerApprovalForm.get('reportingOfficialZip').invalid && this.customerApprovalForm.get('reportingOfficialZip').touched
                  }"
                      >
                  <div *ngIf="this.customerApprovalForm.get('reportingOfficialZip').invalid && (this.customerApprovalForm.get('reportingOfficialZip').touched
                || this.customerApprovalForm.get('reportingOfficialZip').dirty)">
                      <small class="text-danger">
                        <span class="fa fa-warning"></span> Zip Code is required
                      </small>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-5">
                    <label for="reporting_country">Country</label>
                    <select id="reporting_country" class="w-100"  title="reporting_country"  name="country" formControlName="reportingOfficialCountry">
                      <option [value]='null' selected disabled>Choose...</option>
                      <option *ngFor='let c of countryList' [value]="c.stateCountryName">{{c.stateCountryName}}</option>
                    </select>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-5">
                    <label for="reporting_phone">Phone</label>
                    <input type="text" id="reporting_phone" class="w-100" formControlName="reportingOfficialPhone" [maxlength]="20"
                        [ngClass]="{
                    'border-success': this.customerApprovalForm.get('reportingOfficialPhone').valid && this.customerApprovalForm.get('reportingOfficialPhone').touched,
                    'border-danger': this.customerApprovalForm.get('reportingOfficialPhone').invalid && this.customerApprovalForm.get('reportingOfficialPhone').touched
                  }"
                      >
                    <span class="help-text text-muted">Do not include spaces or dashes.</span>
                  <div *ngIf="this.customerApprovalForm.get('reportingOfficialPhone').invalid && (this.customerApprovalForm.get('reportingOfficialPhone').touched
                  || this.customerApprovalForm.get('reportingOfficialPhone').dirty)">
                      <small class="text-danger">
                        <span class="fa fa-warning"></span> Phone is required
                      </small>
                    </div>
                  <div *ngIf="this.customerApprovalForm.get('reportingOfficialPhone').invalid && (this.customerApprovalForm.get('reportingOfficialPhone').touched
                  || this.customerApprovalForm.get('reportingOfficialPhone').dirty)">
                      <small class="text-danger">
                        <span class="fa fa-warning"></span> Invalid phone number
                      </small>
                    </div>
                  <div *ngIf="this.customerApprovalForm.get('reportingOfficialPhone').invalid && (this.customerApprovalForm.get('reportingOfficialPhone').touched
                  || this.customerApprovalForm.get('reportingOfficialPhone').dirty)">
                      <small class="text-danger">
                        <span class="fa fa-warning"></span> Phone number must be at least 10 digits
                      </small>
                    </div>

                  </div>
                  <div class="form-group col-md-2">
                    <label for="reporting_phone_ext">Ext</label>
                    <input type="text" id="reporting_phone_ext" class="w-100" formControlName="reportingOfficialPhoneExtension" appNumbersOnly [maxlength]="14">

                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-5">
                    <label for="reporting_email">Email</label>
                    <input type="text" id="reporting_email" class="w-100" formControlName="reportingOfficialEmail" readonly [maxlength]="254"
                        [ngClass]="{
                    'border-success': this.customerApprovalForm.get('reportingOfficialEmail').valid && this.customerApprovalForm.get('reportingOfficialEmail').touched,
                    'border-danger': this.customerApprovalForm.get('reportingOfficialEmail').invalid && this.customerApprovalForm.get('reportingOfficialEmail').touched
                  }"
                      >
                  <div *ngIf="this.customerApprovalForm.get('reportingOfficialEmail').invalid && (this.customerApprovalForm.get('reportingOfficialEmail').touched
                || this.customerApprovalForm.get('reportingOfficialEmail').dirty)">
                      <small class="text-danger">
                        <span class="fa fa-warning"></span> Email is required
                      </small>
                    </div>
                  </div>
                </div>

                <h5>Approval</h5>
                <div class="form-row">
                  <div class="form-group col-md-5">
                    <label for="status">Status<small class="required">*</small></label>
                    <select id="status" class="w-100" formControlName="registrationStatus" title="registration_Status" name="registrationStatus">
                      <option [value]='null' selected disabled>Choose...</option>
                      <option *ngFor='let s of statusTypes' [value]="s">{{s}}</option>
                    </select>
                  </div>
                </div>
                <div class="form-row" *ngIf="this.customerApprovalForm.get('registrationStatus').value==='Reject'">
                  <div class="form-group col-md-5 pb-3">
                    <label for="comments">Reason<small class="required">*</small></label>
                    <textarea required class="w-100 h-75" formControlName="rejectReason" id="comments"></textarea>
                  </div>
                </div>
              </div>
              <div class="mt-4">
                <button type="button" class="btn btn-primary w-auto" *ngIf="!registrationSuccessful" [disabled]="customerApprovalForm.invalid || this.checkSelectControlsSelected() || (this.isRegistrationRejected && this.registrationStatus === 'Accept') || this.permissionsSelected()" (click)='updateCustomer(this.customerApprovalForm.value)'>Submit</button>
                <button type="button" class="btn btn-outline-secondary w-auto ml-4" (click)='callCustomerApprovalList()'>Back To Customer Approval</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>-->
